
import { isSignedIn } from './services/user'
import { initialising, loading } from './services/game'

import Screen from './components/Screen.vue'
import Debug from './components/Debug.vue'
import SignInOrRegister from './components/account/SignInOrRegister.vue'
import Loading from './components/common/Loading.vue'

export default {
  name: 'App',
  components: {
    Screen,
    Debug,
    SignInOrRegister,
    Loading
  },
  setup() {
    return { isSignedIn, initialising, loading }
  }
}
